import { RefObject, useEffect } from 'react';

type UseClickOutsideOptions = {
  ignoreSelector?: string;
};

function useClickOutside<T extends HTMLElement>(
  ref: RefObject<T | null>,
  callback: Function,
  options?: UseClickOutsideOptions,
) {
  const { ignoreSelector } = options ?? {};

  const handleClick = (e: MouseEvent | TouchEvent) => {
    if (!ref.current || ref.current.contains(e.target as HTMLElement)) {
      return;
    }
    if (ignoreSelector && (e.target as HTMLElement).closest(ignoreSelector)) {
      return;
    }
    callback(e);
  };

  useEffect(() => {
    window.addEventListener('mousedown', handleClick);
    window.addEventListener('touchstart', handleClick);

    return () => {
      window.removeEventListener('mousedown', handleClick);
      window.removeEventListener('touchstart', handleClick);
    };
  }, [ref, callback, ignoreSelector]);
}

export { useClickOutside };
